import { COMPANY_NAME, COMPANY_REGION, COMPANY_SHORT, COMPANY_LOCATION, PROFILE_FACTS } from '../constants';

function HeroSection() {
  return (
    <section className="relative overflow-hidden bg-cream">
      <div
        aria-hidden
        className="pointer-events-none absolute -left-32 top-10 h-80 w-80 rounded-full bg-blush blur-3xl opacity-70"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute -right-24 bottom-0 h-72 w-72 rounded-full bg-petal blur-3xl opacity-80"
      />
      <div className="relative mx-auto max-w-5xl px-6 pt-20 pb-24 text-center lg:pt-28 lg:pb-32">
        <span className="inline-flex items-center gap-2 rounded-pill border border-rose/30 bg-petal/70 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.22em] text-rose">
          <span className="h-1.5 w-1.5 rounded-full bg-rose" />
          Public Profile · {COMPANY_REGION}
        </span>
        <h1 className="font-display mt-7 text-5xl font-semibold leading-[1.05] tracking-tight text-plum sm:text-6xl lg:text-7xl">
          {COMPANY_NAME}
        </h1>
        <p className="mx-auto mt-7 max-w-2xl text-lg leading-8 text-ink/70">
          A calm, modern public profile for {COMPANY_SHORT} based in {COMPANY_LOCATION}.
        </p>
        <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href="#care"
            className="rounded-pill bg-plum px-7 py-3.5 font-semibold text-petal shadow-soft transition hover:bg-rose"
          >
            Our approach
          </a>
          <a
            href="#visit"
            className="rounded-pill border border-plum/25 bg-white px-7 py-3.5 font-semibold text-plum transition hover:border-plum hover:bg-petal"
          >
            See address
          </a>
        </div>

        <div className="mx-auto mt-16 grid max-w-4xl gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {PROFILE_FACTS.map((fact) => (
            <div
              key={fact.label}
              className="rounded-3xl border border-line/80 bg-white/70 px-5 py-5 text-left backdrop-blur"
            >
              <p className="text-[11px] font-black uppercase tracking-[0.22em] text-rose">
                {fact.label}
              </p>
              <p className="font-display mt-2 text-xl text-plum">{fact.value}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
